





















import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import HelloBlock from '@/components/modules/App/Profile/HelloBlock.vue';
import ConsultationBanner from '@/components/modules/App/ConsultationBanner.vue';
import FlatsList from '@/components/modules/App/Profile/FlatsList.vue';
import ActionsList from '@/components/modules/App/Profile/ActionsList.vue';
import Calculator from '@/components/modules/App/CalculatorComponent/CalculatorComponent.vue';
import LifeLine from '@/components/modules/App/Profile/LifeLine.vue';
import NewlyBoughtFlat from '@/components/modules/App/Profile/NewlyBoughtFlat.vue';
import { initStoreModule } from '@/utils/helpers/storeHelpers';
import { CatalogItem, Profile, Deal, Action } from '@/requests/mainApi';
import { LeadV1LeadListRequest } from '@/requests/mainApi/apis/LeadApi';
import { storeModuleName as profileStoreModule, store } from '@/views/App/Profile/store'

interface Data {
  timeToOpenPage: number;
  dealBeingFinished: Deal | undefined;
}

interface Methods {
  analyticsSend: () => void;
  getBookingFlats: () => void;
  getMyFlats: () => Promise<void>;
  getDeal: () => Promise<void>;
  getActions: () => Promise<void>;
  getActionMain: () => Promise<void>;
  tryFinishDeal: () => Promise<Deal>;
  setDeal: (deal: Deal) => void;
  showMainActionIfNeeded: () => void;
  setMainActionModalOpened: (value: boolean) => void;
}

interface Computed {
  viewHelloBlock: boolean;
  displayLifeLine: boolean;
  isDealBeingFinished: boolean;
  myFlats: CatalogItem[];
  myDealsPagination: { next: LeadV1LeadListRequest; prev: LeadV1LeadListRequest };
  userData: Profile;
  deal: Deal;
  actionMain: Action
}

interface Props {}

export default initStoreModule(profileStoreModule, store).extend({
  name: 'Profile',
  components: {
    HelloBlock,
    FlatsList,
    ActionsList,
    Calculator,
    ConsultationBanner,
    LifeLine,
    NewlyBoughtFlat,
  },
  data() {
    return {
      timeToOpenPage: new Date().getTime(),
      dealBeingFinished: undefined,
    };
  },
  computed: {
    viewHelloBlock() {
      return !this.userData.isVerified || this.myFlats.length === 0 || (this.deal && this.deal.stage);
    },
    displayLifeLine() {
      return this.deal && this.deal.estate && !this.isDealBeingFinished;
    },
    isDealBeingFinished() {
      return this.dealBeingFinished && this.dealBeingFinished.stage;
    },
    ...mapGetters(profileStoreModule, ['myFlats', 'myDealsPagination', 'actionMain']),
    ...mapGetters(['userData', 'deal']),
  },
  async created() {
    this.$analytics.logEvent('go_main', { screen: 'main' });
    window.addEventListener('beforeunload', this.analyticsSend);
    this.getBookingFlats();
    this.getMyFlats();
    this.getDeal();
    this.getActions();
    this.getActionMain();
    this.dealBeingFinished = await this.tryFinishDeal();

    setTimeout(() => {
      this.showMainActionIfNeeded();
    }, 500)
  },
  updated() {
    const anchor = this.$router.currentRoute.hash;
    if (anchor && document.querySelector(anchor)) {
      location.href = anchor;
    }
  },
  beforeDestroy() {
    this.analyticsSend();
    window.removeEventListener('beforeunload', this.analyticsSend);
  },
  methods: {
    analyticsSend() {
      this.$analytics.logEvent('main', {
        screen: 'main',
        time: Math.round((new Date().getTime() - this.timeToOpenPage) / 1000),
      });
    },
    finishDeal() {
      this.dealBeingFinished = undefined;
      this.setDeal({});
    },
    showMainActionIfNeeded() {
      if (!this.actionMain) {
        return;
      }

      const getDateLocalStorage = (actionId: number): string => {
        return `mainAction${actionId}Date`;
      }

      const getCurrentDate = (): number => {
        const now = new Date();
        now.setHours(0, 0, 0, 0);

        return Math.floor(now.getTime() / 1000);
      }

      const localStorageKey = 'mainAction';
      const currentDate = getCurrentDate();
      const mainActionDateKey = getDateLocalStorage(this.actionMain.id);

      let isMainActionIdChanged = false;
      let isMainActionTitleChanged = false;
      let isMainActionPreviewImageChanged = false;
      let isMainActionDateChanged = false;

      const storedMainActionJson = window.localStorage.getItem(localStorageKey);
      if (storedMainActionJson) {
        const storedMainAction = JSON.parse(storedMainActionJson) as Action;

        isMainActionIdChanged = storedMainAction.id !== this.actionMain.id;
        isMainActionTitleChanged = storedMainAction.title !== this.actionMain.title;
        isMainActionPreviewImageChanged = storedMainAction.previewImage !== this.actionMain.previewImage;

        const storedDate = Number(window.localStorage.getItem(mainActionDateKey));

        isMainActionDateChanged = storedDate < currentDate;
      }

      if (
        !storedMainActionJson || isMainActionIdChanged || isMainActionTitleChanged ||
        isMainActionPreviewImageChanged || isMainActionDateChanged
      ) {
        this.setMainActionModalOpened(true);
        window.localStorage.setItem(localStorageKey, JSON.stringify(this.actionMain));
        window.localStorage.setItem(mainActionDateKey, String(currentDate));
      }
    },
    ...mapActions(profileStoreModule, [
      'getBookingFlats',
      'getMyFlats',
      'getActions',
      'getActionMain',
      'getDeal',
      'tryFinishDeal'
    ]),
    ...mapMutations(['setDeal', 'setMainActionModalOpened']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
